import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Slide,
  Grid,
  IconButton,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Box,
  Paper,
  TextField,
  Chip,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import getArticleService from "../../../../services/getArticleService";
import CloseIcon from "@mui/icons-material/Close";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import ImageIcon from "@mui/icons-material/Image";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import PendingIcon from "@mui/icons-material/Pending";
import EditIcon from "@mui/icons-material/Edit";
import { NotificationManager } from "react-notifications";
import moment from "moment";
import { useAuth } from "../../../../context/AuthContext";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const ViewPaymentProof = ({
  setIsOpenView,
  isOpenView,
  articleData,
  reFetchData,
}) => {
  const { userRole } = useAuth();
  const [preSignedUrls, setPreSignedUrls] = useState({});
  const [selectedImage, setSelectedImage] = useState(null);
  const [openImageDialog, setOpenImageDialog] = useState(false);
  const [openPdfDialog, setOpenPdfDialog] = useState(false);
  const [selectedPdf, setSelectedPdf] = useState(null);
  const [paymentUpdates, setPaymentUpdates] = useState({});
  const [loading, setLoading] = useState({});
  const [editingFields, setEditingFields] = useState({});
  const [openDiscountDialog, setOpenDiscountDialog] = useState(false);
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [discountForm, setDiscountForm] = useState({
    discountAmount: "",
    discountPercent: "",
  });
  const [discountErrors, setDiscountErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    console.log(
      "ViewPaymentProof mounted/updated with articleData:",
      articleData
    );
    if (articleData?.payments) {
      console.log("Payments data:", articleData.payments);
      // Initialize payment updates with existing data
      const initialUpdates = {};
      articleData.payments.forEach((payment) => {
        initialUpdates[payment.paymentId] = {
          utrNo: payment.utrNo || "",
          creditDate: payment.creditDate || "",
        };
      });
      setPaymentUpdates(initialUpdates);
    }
  }, [articleData]);

  const handleClose = () => {
    setIsOpenView(false);
    setPreSignedUrls({});
    setPaymentUpdates({});
    setEditingFields({});
  };

  const toggleFieldEdit = (paymentId) => {
    setEditingFields((prev) => ({
      ...prev,
      [paymentId]: !prev[paymentId],
    }));
  };

  const handleImageClick = (fileKey) => {
    // Check if the file is a PDF
    if (fileKey.toLowerCase().endsWith(".pdf")) {
      setSelectedPdf(fileKey);
      setOpenPdfDialog(true);
    } else {
      setSelectedImage(fileKey);
      setOpenImageDialog(true);
    }
  };

  const handlePdfClick = (pdfKey) => {
    setSelectedPdf(pdfKey);
    setOpenPdfDialog(true);
  };

  const handleCloseImageDialog = () => {
    setOpenImageDialog(false);
    setSelectedImage(null);
  };

  const handleClosePdfDialog = () => {
    setOpenPdfDialog(false);
    setSelectedPdf(null);
  };

  const handleUpdateChange = (paymentId, field, value) => {
    setPaymentUpdates((prev) => ({
      ...prev,
      [paymentId]: {
        ...prev[paymentId],
        [field]: value,
      },
    }));
  };

  const handleFieldUpdate = async (paymentId) => {
    try {
      setLoading((prev) => ({ ...prev, [paymentId]: true }));

      const updateData = {
        paymentId,
        utrNo: paymentUpdates[paymentId].utrNo,
        creditDate: paymentUpdates[paymentId].creditDate,
        PublicationId: articleData.PublicationId,
      };

      const response = await getArticleService.updatePaymentDetails(
        articleData.id,
        updateData
      );

      if (response) {
        // Update the local state with new data
        const updatedPayments = articleData.payments.map((payment) =>
          payment.paymentId === paymentId
            ? { ...payment, ...updateData }
            : payment
        );
        articleData.payments = updatedPayments;
        // Close edit mode after successful update
        setEditingFields((prev) => ({
          ...prev,
          [paymentId]: false,
        }));

        reFetchData();
      }
    } catch (error) {
      console.error("Error updating payment:", error);
    } finally {
      setLoading((prev) => ({ ...prev, [paymentId]: false }));
    }
  };

  const fetchData = async () => {
    console.log("Fetching data for articleData:", articleData);
    console.log("Payments array:", articleData?.payments);

    if (!articleData?.payments || !Array.isArray(articleData.payments)) {
      console.log("No valid payments data found");
      return;
    }

    const urls = {};
    const payments = articleData.payments;
    console.log("Processing payments:", payments);

    for (const payment of payments) {
      console.log("Processing payment:", payment);

      // Fetch invoice PDF URL if exists
      if (payment.invoiceKey) {
        try {
          console.log("Fetching invoice URL for:", payment.invoiceKey);
          const data = await getArticleService.getFilePreSIgnedUrl({
            key: payment.invoiceKey,
          });
          urls[payment.invoiceKey] = data;
        } catch (error) {
          console.error("Error fetching PDF URL:", error);
        }
      }

      // Fetch payment proof image URLs
      if (
        payment.paymentProofFileKeys &&
        Array.isArray(payment.paymentProofFileKeys)
      ) {
        console.log("Processing payment proofs:", payment.paymentProofFileKeys);
        for (const proof of payment.paymentProofFileKeys) {
          try {
            console.log("Fetching proof URL for:", proof);
            const data = await getArticleService.getFilePreSIgnedUrl({
              key: proof,
            });
            urls[proof] = data;
          } catch (error) {
            console.error("Error fetching image URL:", error);
          }
        }
      }
    }
    console.log("Generated URLs:", urls);
    setPreSignedUrls(urls);
  };

  useEffect(() => {
    if (articleData?.payments && Array.isArray(articleData.payments)) {
      console.log("Triggering fetchData for payments");
      fetchData();
    }
  }, [articleData?.payments]);

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  const getPaymentStatus = (utrNo) => {
    if (utrNo && utrNo.trim() !== "") {
      return {
        label: "Payment Confirmed",
        color: "success",
        icon: <CheckCircleIcon />,
      };
    }
    return {
      label: "Payment Pending",
      color: "warning",
      icon: <PendingIcon />,
    };
  };

  const handleOpenDiscountDialog = () => {
    setOpenDiscountDialog(true);
  };

  const handleCloseDiscountDialog = () => {
    setOpenDiscountDialog(false);
    setDiscountForm({ discountAmount: "", discountPercent: "" });
    setDiscountErrors({});
  };

  const handleDiscountChange = (field) => (event) => {
    const value = event.target.value;
    const totalAmount = articleData?.totalfees;

    if (field === "discountAmount") {
      const amount = parseFloat(value);
      const percentage = (amount / totalAmount) * 100;
      setDiscountForm({
        discountAmount: value,
        discountPercent: percentage,
      });
    } else if (field === "discountPercent") {
      const percentage = parseFloat(value);
      const amount = (totalAmount * percentage) / 100;
      setDiscountForm({
        discountAmount: amount,
        discountPercent: value,
      });
    }

    if (discountErrors[field]) {
      setDiscountErrors((prev) => ({
        ...prev,
        [field]: "",
      }));
    }
  };

  const validateDiscountForm = () => {
    const errors = {};
    const discountAmount = parseFloat(discountForm.discountAmount);
    const discountPercent = parseFloat(discountForm.discountPercent);
    const totalAmount = articleData?.totalfees;

    if (!discountAmount || isNaN(discountAmount) || discountAmount <= 0) {
      errors.discountAmount = "Please enter a valid discount amount";
    }

    if (discountAmount > totalAmount) {
      errors.discountAmount = "Discount amount cannot exceed total amount";
    }

    if (
      !discountPercent ||
      isNaN(discountPercent) ||
      discountPercent <= 0 ||
      discountPercent > 100
    ) {
      errors.discountPercent =
        "Please enter a valid discount percentage (1-100)";
    }

    setDiscountErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleDiscountSubmit = () => {
    if (validateDiscountForm()) {
      setOpenConfirmDialog(true);
    }
  };

  const handleConfirmDiscount = async () => {
    try {
      setIsSubmitting(true);
      const response = await getArticleService.addDiscountToArticle({
        articleid: articleData.id,
        discountAmount: parseFloat(discountForm.discountAmount),
        discountPercent: parseFloat(discountForm.discountPercent),
      });

      console.log("response", response);

      if (response.success) {
        handleCloseDiscountDialog();
        setOpenConfirmDialog(false);
        reFetchData();

        // if (updatedArticleResponse && updatedArticleResponse.articles) {
        //   // Find the specific article in the response
        //   const updatedArticle = updatedArticleResponse.articles.find(
        //     article => article.id === articleData.id
        //   );

        //   if (updatedArticle) {
        //     // Update the local state with the new data
        //     setArticleData(updatedArticle);
        //   }
        // }

        // handleCloseDiscountDialog();
        // setOpenConfirmDialog(false);
      } else {
        NotificationManager.error(
          response.message || "Failed to apply discount"
        );
      }
    } catch (error) {
      console.error("Error applying discount:", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <Dialog
        open={isOpenView}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        fullWidth={true}
        maxWidth={"md"}
      >
        <DialogTitle className="pt-3 modal_header_dealog">
          Payment History
        </DialogTitle>

        <DialogContent>
          {articleData?.payments && Array.isArray(articleData.payments) ? (
            <Box sx={{ mt: 2 }}>
              {articleData.payments.map((payment, index) => {
                const status = getPaymentStatus(payment.utrNo);
                const isEditing = editingFields[payment.paymentId];
                return (
                  <Accordion key={payment.paymentId} sx={{ mb: 2 }}>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      sx={{
                        backgroundColor: "background.paper",
                        "&:hover": {
                          backgroundColor: "action.hover",
                        },
                      }}
                    >
                      <Grid container alignItems="center" spacing={2}>
                        <Grid item xs={12} sm={3}>
                          <Typography variant="subtitle1">
                            Payment #{index + 1}
                          </Typography>
                        </Grid>
                        <Grid item xs={12} sm={3}>
                          <Typography variant="body2" color="text.secondary">
                            {formatDate(payment.paymentDate)}
                          </Typography>
                        </Grid>
                        <Grid item xs={12} sm={3}>
                          <Typography variant="subtitle1" color="primary">
                            {payment.amount}
                          </Typography>
                        </Grid>
                        <Grid item xs={12} sm={3}>
                          <Chip
                            icon={status.icon}
                            label={status.label}
                            color={status.color}
                            size="small"
                            sx={{ minWidth: "120px" }}
                          />
                        </Grid>
                      </Grid>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Grid container spacing={2}>
                        <Grid item xs={12}>
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              mb: 1,
                            }}
                          >
                            <Typography variant="subtitle2">
                              Payment Details
                            </Typography>
                            {userRole !== "tl" && (
                              <Button
                                startIcon={<EditIcon />}
                                onClick={() => toggleFieldEdit(payment.paymentId)}
                                size="small"
                                color="primary"
                              >
                                {isEditing ? "Cancel" : "Edit"}
                              </Button>
                            )}
                          </Box>
                          <Paper
                            elevation={0}
                            sx={{ p: 2, bgcolor: "background.default" }}
                          >
                            <Grid container spacing={2}>
                              <Grid item xs={12} sm={6}>
                                <Typography
                                  variant="body2"
                                  color="text.secondary"
                                >
                                  Amount: {payment.amount}
                                </Typography>
                              </Grid>
                              <Grid item xs={12} sm={6}>
                                <Typography
                                  variant="body2"
                                  color="text.secondary"
                                >
                                  Date: {formatDate(payment.paymentDate)}
                                </Typography>
                              </Grid>
                              <Grid item xs={12} sm={6}>
                                <Typography
                                  variant="body2"
                                  color="text.secondary"
                                >
                                  Created At: {payment.createdAtDate ? moment(payment.createdAtDate).format("DD-MM-YY hh:mm A") : "Not provided"}
                                </Typography>
                              </Grid>
                              <Grid item xs={12} sm={6}>
                                {isEditing ? (
                                  <TextField
                                    fullWidth
                                    label="UTR Number"
                                    value={
                                      paymentUpdates[payment.paymentId]
                                        ?.utrNo || ""
                                    }
                                    onChange={(e) =>
                                      handleUpdateChange(
                                        payment.paymentId,
                                        "utrNo",
                                        e.target.value
                                      )
                                    }
                                    size="small"
                                  />
                                ) : (
                                  <Typography
                                    variant="body2"
                                    color="text.secondary"
                                  >
                                    UTR Number:{" "}
                                    {payment.utrNo || "Not provided"}
                                  </Typography>
                                )}
                              </Grid>
                              <Grid item xs={12} sm={6}>
                                {isEditing ? (
                                  <TextField
                                    fullWidth
                                    label="Credit Date"
                                    type="date"
                                    value={
                                      paymentUpdates[payment.paymentId]
                                        ?.creditDate || ""
                                    }
                                    onChange={(e) =>
                                      handleUpdateChange(
                                        payment.paymentId,
                                        "creditDate",
                                        e.target.value
                                      )
                                    }
                                    size="small"
                                    InputLabelProps={{ shrink: true }}
                                  />
                                ) : (
                                  <Typography
                                    variant="body2"
                                    color="text.secondary"
                                  >
                                    Credit Date:{" "}
                                    {payment.creditDate
                                      ? formatDate(payment.creditDate)
                                      : "Not provided"}
                                  </Typography>
                                )}
                              </Grid>
                              <Grid item xs={12} sm={6}>
                                <Typography
                                  variant="body2"
                                  color="text.secondary"
                                >
                                  Payment Mode:{" "}
                                  {payment.paymentMode || "Not provided"}
                                </Typography>
                              </Grid>
                              <Grid item xs={12} sm={6}>
                                <Typography
                                  variant="body2"
                                  color="text.secondary"
                                >
                                  Bank: {payment.bank || "Not provided"}
                                </Typography>
                              </Grid>
                              {payment.remark && (
                                <Grid item xs={12}>
                                  <Typography
                                    variant="body2"
                                    color="text.secondary"
                                  >
                                    Remark: {payment.remark}
                                  </Typography>
                                </Grid>
                              )}
                              {isEditing && (
                                <Grid item xs={12}>
                                  <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={() =>
                                      handleFieldUpdate(payment.paymentId)
                                    }
                                    disabled={loading[payment.paymentId]}
                                    sx={{ mt: 1 }}
                                  >
                                    {loading[payment.paymentId]
                                      ? "Updating..."
                                      : "Save Changes"}
                                  </Button>
                                </Grid>
                              )}
                            </Grid>
                          </Paper>
                        </Grid>

                        {/* Invoice Section */}
                        {payment.invoiceKey && (
                          <Grid item xs={12}>
                            <Typography variant="subtitle2" gutterBottom>
                              Invoice
                            </Typography>
                            <Button
                              variant="outlined"
                              startIcon={<PictureAsPdfIcon />}
                              onClick={() => handlePdfClick(payment.invoiceKey)}
                              sx={{ mb: 2 }}
                            >
                              View Invoice
                            </Button>
                          </Grid>
                        )}

                        {/* Payment Proofs Section */}
                        {payment.paymentProofFileKeys &&
                          payment.paymentProofFileKeys.length > 0 && (
                            <Grid item xs={12}>
                              <Typography variant="subtitle2" gutterBottom>
                                Payment Proofs
                              </Typography>
                              <Grid container spacing={2}>
                                {payment.paymentProofFileKeys.map(
                                  (proof, proofIndex) => {
                                    const isPdf = proof
                                      .toLowerCase()
                                      .endsWith(".pdf");
                                    return (
                                      <Grid
                                        item
                                        key={proofIndex}
                                        xs={6}
                                        sm={4}
                                        md={3}
                                      >
                                        <Paper
                                          elevation={0}
                                          sx={{
                                            p: 1,
                                            cursor: "pointer",
                                            "&:hover": {
                                              bgcolor: "action.hover",
                                            },
                                          }}
                                          onClick={() =>
                                            handleImageClick(proof)
                                          }
                                        >
                                          {preSignedUrls[proof] ? (
                                            isPdf ? (
                                              <Box
                                                sx={{
                                                  width: "100%",
                                                  height: "150px",
                                                  display: "flex",
                                                  flexDirection: "column",
                                                  alignItems: "center",
                                                  justifyContent: "center",
                                                  bgcolor: "background.default",
                                                  borderRadius: "4px",
                                                  gap: 1,
                                                }}
                                              >
                                                <PictureAsPdfIcon
                                                  sx={{
                                                    fontSize: 40,
                                                    color: "error.main",
                                                  }}
                                                />
                                                <Typography
                                                  variant="caption"
                                                  color="text.secondary"
                                                >
                                                  PDF Document
                                                </Typography>
                                              </Box>
                                            ) : (
                                              <img
                                                src={preSignedUrls[proof]}
                                                alt={`Payment Proof ${
                                                  proofIndex + 1
                                                }`}
                                                style={{
                                                  width: "100%",
                                                  height: "150px",
                                                  objectFit: "cover",
                                                  borderRadius: "4px",
                                                }}
                                              />
                                            )
                                          ) : (
                                            <Box
                                              sx={{
                                                width: "100%",
                                                height: "150px",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                bgcolor: "background.default",
                                                borderRadius: "4px",
                                              }}
                                            >
                                              {isPdf ? (
                                                <PictureAsPdfIcon />
                                              ) : (
                                                <ImageIcon />
                                              )}
                                            </Box>
                                          )}
                                        </Paper>
                                      </Grid>
                                    );
                                  }
                                )}
                              </Grid>
                            </Grid>
                          )}
                      </Grid>
                    </AccordionDetails>
                  </Accordion>
                );
              })}
            </Box>
          ) : (
            <Typography variant="h6" align="center" sx={{ mt: 3 }}>
              No Payment History Available
            </Typography>
          )}

          {/* Discount History Section */}
          <Box sx={{ mt: 4 }}>
            <Typography variant="h6" gutterBottom>
              Discount History
            </Typography>
            {articleData?.discounts && articleData.discounts.length > 0 ? (
              <Box sx={{ mt: 2 }}>
                {articleData.discounts.map((discount, index) => (
                  <Accordion key={index} sx={{ mb: 2 }}>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      sx={{
                        backgroundColor: "background.paper",
                        "&:hover": {
                          backgroundColor: "action.hover",
                        },
                      }}
                    >
                      <Grid container alignItems="center" spacing={2}>
                        <Grid item xs={12} sm={4}>
                          <Typography variant="subtitle1">
                            Discount #{index + 1}
                          </Typography>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <Typography variant="subtitle1" color="success.main">
                            -{discount.discountAmount}
                          </Typography>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <Typography variant="body2" color="text.secondary">
                            {moment(discount.appliedOn).format("MMMM D, YYYY")}
                          </Typography>
                        </Grid>
                      </Grid>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Paper
                        elevation={0}
                        sx={{ p: 2, bgcolor: "background.default" }}
                      >
                        <Grid container spacing={2}>
                          <Grid item xs={12} sm={6}>
                            <Typography variant="body2" color="text.secondary">
                              Discount Amount: -{discount.discountAmount}
                            </Typography>
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            <Typography variant="body2" color="text.secondary">
                              Discount Percentage: {discount.discountPercent}%
                            </Typography>
                          </Grid>
                          <Grid item xs={12}>
                            <Typography variant="body2" color="text.secondary">
                              Applied On:{" "}
                              {moment(discount.appliedOn).format(
                                "MMMM D, YYYY, h:mm A"
                              )}
                            </Typography>
                          </Grid>
                        </Grid>
                      </Paper>
                    </AccordionDetails>
                  </Accordion>
                ))}
              </Box>
            ) : (
              <Typography variant="body1" color="text.secondary" align="center">
                No discount history available
              </Typography>
            )}
          </Box>
        </DialogContent>
        <DialogActions className="pb-3">
          {userRole !== "tl" && (
            <Button
              variant="contained"
              color="primary"
              onClick={handleOpenDiscountDialog}
              sx={{ mr: 1 }}
            >
              Add Discount
            </Button>
          )}
          <Button variant="contained" color="error" onClick={handleClose}>
            Close
          </Button>
        </DialogActions>
      </Dialog>

      {/* Image Preview Dialog */}
      <Dialog
        open={openImageDialog}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleCloseImageDialog}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 2,
            boxShadow: "0px 0px 20px rgba(0, 0, 0, 0.15)",
          },
        }}
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            borderBottom: "1px solid",
            borderColor: "divider",
            p: 2,
          }}
        >
          Payment Proof
          <IconButton
            aria-label="close"
            onClick={handleCloseImageDialog}
            sx={{
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ p: 2 }}>
          {selectedImage && preSignedUrls[selectedImage] && (
            <img
              src={preSignedUrls[selectedImage]}
              alt="Payment Proof"
              style={{
                width: "100%",
                height: "auto",
                maxHeight: "70vh",
                objectFit: "contain",
                borderRadius: 4,
              }}
            />
          )}
        </DialogContent>
      </Dialog>

      {/* PDF Preview Dialog */}
      <Dialog
        open={openPdfDialog}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClosePdfDialog}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 2,
            boxShadow: "0px 0px 20px rgba(0, 0, 0, 0.15)",
          },
        }}
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            borderBottom: "1px solid",
            borderColor: "divider",
            p: 2,
          }}
        >
          Invoice
          <IconButton
            aria-label="close"
            onClick={handleClosePdfDialog}
            sx={{
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ p: 2, height: "80vh" }}>
          {selectedPdf && preSignedUrls[selectedPdf] && (
            <iframe
              src={preSignedUrls[selectedPdf]}
              style={{
                width: "100%",
                height: "100%",
                border: "none",
                borderRadius: 4,
              }}
              title="Invoice PDF"
            />
          )}
        </DialogContent>
      </Dialog>

      {/* Discount Form Dialog */}
      <Dialog
        open={openDiscountDialog}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleCloseDiscountDialog}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          <IconButton
            aria-label="close"
            onClick={handleCloseDiscountDialog}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Box sx={{ mt: 2 }}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography variant="subtitle2" gutterBottom>
                  Total Amount: {articleData?.totalfees}
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="subtitle2" gutterBottom>
                  Remaining Fees: {articleData?.remaningFees}
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Discount Amount"
                  type="number"
                  value={discountForm.discountAmount}
                  onChange={handleDiscountChange("discountAmount")}
                  error={!!discountErrors.discountAmount}
                  helperText={discountErrors.discountAmount}
                  InputProps={{
                    startAdornment: <Typography></Typography>,
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Discount Percentage"
                  type="number"
                  value={Number(discountForm.discountPercent).toFixed(2)}
                  onChange={handleDiscountChange("discountPercent")}
                  error={!!discountErrors.discountPercent}
                  helperText={discountErrors.discountPercent}
                  InputProps={{
                    endAdornment: <Typography>%</Typography>,
                  }}
                />
              </Grid>
            </Grid>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDiscountDialog}>Cancel</Button>
          <Button
            onClick={handleDiscountSubmit}
            variant="contained"
            color="primary"
          >
            Add Discount
          </Button>
        </DialogActions>
      </Dialog>

      {/* Confirmation Dialog */}
      <Dialog
        open={openConfirmDialog}
        TransitionComponent={Transition}
        keepMounted
        onClose={() => setOpenConfirmDialog(false)}
        maxWidth="sm"
      >
        <DialogTitle>Confirm Discount</DialogTitle>
        <DialogContent>
          <Typography>
            Are you sure you want to apply a discount of 
            {discountForm.discountAmount} ({discountForm.discountPercent}%)?
            This action cannot be reversed.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenConfirmDialog(false)}>Cancel</Button>
          <Button
            onClick={handleConfirmDiscount}
            variant="contained"
            color="primary"
            disabled={isSubmitting}
          >
            {isSubmitting ? "Applying..." : "Confirm"}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ViewPaymentProof;
